module.exports = __webpack_public_path__ + "static/image/company/pc/image_sustainable_policy.ver2_0_2.jpg?794c8f3a";